<template>
  <span class="text-neutral-dark-0 ml-3 font-bold"><slot /></span>
</template>
